import React, { useEffect, useState } from 'react';
import apiService from '../../../core/services/network.service';
import * as endpoints from '../../../constants/endpoints';

const AnalyticsPage: React.FC = () => {
  const [iframeSrc, setIframeSrc] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    apiService.axiosInstance
      .get(`${endpoints.SERVER_URL}analytics/token/`)
      .then((res) => {
        const { token, company_id } = res.data;
        const params = new URLSearchParams({ token, company_id });
        setIframeSrc(`/analytics/platform-data?${params.toString()}`);
      })
      .catch(() => setError(true));
  }, []);

  if (error) {
    return (
      <div className="d-flex align-items-center justify-content-center h-100">
        <p className="text-danger">Failed to load analytics. Please try again.</p>
      </div>
    );
  }

  if (!iframeSrc) {
    return (
      <div className="d-flex align-items-center justify-content-center h-100">
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  return (
    // Negative margin to cancel wrapper padding, so iframe fills the content area edge-to-edge
    <div style={{ margin: '-1.2em', height: 'calc(100vh - 88px)' }}>
      <iframe
        src={iframeSrc}
        title="Analytics Dashboard"
        style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
      />
    </div>
  );
};

export default AnalyticsPage;
